export default {
    to: "/dashboard/waas/",
    order: 3,
    icon: "mdi-currency-usd",
    title: "Payments",
    disabled: false,
    value: 0,
    sublinks: [
        {
            to: "/dashboard/waas/payments/request",
            order: 3,
            icon: "mdi-frequently-asked-questions",
            title: "Request Payments",
            disabled: false,
            value: 0,
        },
        {
            to: "/dashboard/waas/payments/till",
            order: 3,
            icon: "mdi-contactless-payment",
            title: "Till Payments",
            disabled: false,
            value: 0,
        },
        {
            to: "/dashboard/waas/payments/lipa-fare",
            order: 3,
            icon: "mdi-car-arrow-right",
            title: "Lipa Fare",
            disabled: false,
            value: 0,
        },
    ]
}
